/**
 * Product Logo Component
 *
 * Renders a product logo image based on product ID.
 * Handles image imports here to keep constants testable.
 */

import { Image, ImageSourcePropType, ImageStyle, StyleProp } from 'react-native';

import type { ProductId } from '@/constants/medicalOnDemand';

const PRODUCT_LOGOS: Record<ProductId, ImageSourcePropType> = {
  tecvayli: require('@/assets/images/product-logos/generic/pharma-product-1.png'),
  talvey: require('@/assets/images/product-logos/generic/pharma-product-2.png'),
};

type ProductLogoProps = {
  productId: ProductId;
  size?: number;
  style?: StyleProp<ImageStyle>;
  accessibilityLabel?: string;
};

export function ProductLogo({ productId, size = 25, style, accessibilityLabel }: ProductLogoProps) {
  const logo = PRODUCT_LOGOS[productId] ?? PRODUCT_LOGOS['tecvayli'];

  return (
    <Image
      source={logo}
      style={[{ width: size, height: size }, style]}
      resizeMode="contain"
      accessibilityLabel={accessibilityLabel}
    />
  );
}
